//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as d3 from 'd3';
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      COLOR: {
        VOLUME: '#2e75ee',
        FEE: '#ec0',
      },
      filters: {
        dateFrom: '',
        dateTo: '',
      },
    };
  },

  computed: {
    ...mapState('statisticsTradeTurnover', ['chart', 'additionalChart']),

    data() {
      const { chart } = this;
      return !chart.length ? [] : chart.map((e) => ({
        a1: e.equivalentAmount,
        a2: e.equivalentFee,
        t: new Date(e.dateTimeUtc.toString()),
      })).sort((a, b) => b.t - a.t);
    },

    yAxisInterval() {
      const { data } = this;
      const arr = [];

      data.forEach((e) => {
        arr.push(e.a1);
        arr.push(e.a2);
      });

      const min = Math.min.apply(null, arr);
      const max = Math.max.apply(null, arr);

      return [min, max];
    },
  },

  watch: {
    chart() {
      this.drawChart();
    },
  },

  async mounted() {
    await this.loadChartAction();
  },

  methods: {
    ...mapActions('statisticsTradeTurnover', {
      loadChartAction: 'loadChart',
    }),
    drawChart() {
      d3.selectAll('svg.chart-tradeturnover g').remove(); // remove all

      const {
        data,
        yAxisInterval,
        COLOR,
      } = this;
      const { clientWidth, clientHeight } = this.$refs.chartTradeTurnover;
      const margin = {
        top: 20,
        right: 20,
        bottom: 30,
        left: 80,
      };
      const width = clientWidth - margin.left - margin.right;
      const height = clientHeight - margin.top - margin.bottom;

      const svg = d3.select('svg.chart-tradeturnover');

      const g = svg.append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`);

      // set x-axis scale
      const x = d3.scaleTime()
        .rangeRound([0, width]);

      // set y-axis scale
      const y = d3.scaleLinear()
        .rangeRound([height, 0]);

      // create graphs
      const volumeLine = d3.line()
        .x((d) => x(d.t))
        .y((d) => y(d.a1));

      const volumeFee = d3.line()
        .x((d) => x(d.t))
        .y((d) => y(d.a2));

      // set range
      x.domain(d3.extent(data, (d) => d.t));
      y.domain(yAxisInterval);

      g.append('g')
        .attr('transform', `translate(0, ${height})`)
        .call(d3.axisBottom(x));

      g.append('g')
        .call(d3.axisLeft(y))
        .append('text')
        .attr('fill', '#000')
        .attr('transform', 'rotate(-90)')
        .attr('y', 6)
        .attr('dy', '0.7em')
        .attr('text-anchor', 'end')
        .text(`in ${this.additionalChart.equivalentCurrencyTitle}`);

      g.append('path')
        .datum(data)
        .attr('fill', 'none')
        .attr('stroke', COLOR.VOLUME)
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', 1.5)
        .attr('d', volumeLine);

      g.append('path')
        .datum(data)
        .attr('fill', 'none')
        .attr('stroke', COLOR.FEE)
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', 1.5)
        .attr('d', volumeFee);
    },
  },
};
